import { createTheme, ThemeOptions } from "@mui/material/styles";

const effaiColors = {
  primary: {
    main: "#00A19C",
    dark: "#008C87",
    light: "#92D6D5",
  },
  secondary: {
    main: "#80142B",
  },
  dark: "#181818",
  light: "#E6E6E6",
  background: {
    dark: {
      level1: "#1A1A1A",
      level2: "#3F3F3F",
    },
  },
  conditional: {
    error: "#EF5350",
    warning: "#FF9800",
    success: "#4CAF50",
  },
};

declare module "@mui/material/styles" {
  interface Palette {
    conditional: {
      error: string;
      warning: string;
      success: string;
    };
  }
  interface PaletteOptions {
    conditional?: {
      error?: string;
      warning?: string;
      success?: string;
    };
  }
}

export const authTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: effaiColors.primary.main,
      dark: effaiColors.primary.dark,
      light: effaiColors.primary.light,
      contrastText: "#fff",
    },
    secondary: {
      main: effaiColors.secondary.main,
      contrastText: "#fff",
    },
    background: {
      default: effaiColors.background.dark.level1,
      paper: effaiColors.background.dark.level2,
    },
    text: {
      primary: effaiColors.light,
      secondary: effaiColors.primary.light,
    },
    divider: "rgba(255, 255, 255, 0.12)",
    conditional: {
      error: effaiColors.conditional.error,
      warning: effaiColors.conditional.warning,
      success: effaiColors.conditional.success,
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          "&::-webkit-scrollbar": {
            width: "20px",
            height: "20px",
          },
          "&::-webkit-scrollbar-button": {
            display: "none",
          },
          "&::-webkit-scrollbar-track": {
            background: effaiColors.background.dark.level2,
            borderRadius: "999px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#6B6B6B",
            borderRadius: "999px",
            border: `3px solid ${effaiColors.background.dark.level2}`,
            "&:hover": {
              background: "#8B8B8B",
            },
          },
          scrollbarWidth: "auto",
          scrollbarColor: `#6B6B6B ${effaiColors.background.dark.level2}`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          fontWeight: 500,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: effaiColors.background.dark.level2,
        },
      },
    },
  },
} as ThemeOptions);

